import type { SVGProps } from "react";
const SvgCheckedBaggage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <defs>
      <linearGradient
        id="checkedBaggage_svg__c"
        x1={21.517}
        x2={21.517}
        y1={27.845}
        y2={28.431}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="checkedBaggage_svg__e"
        x1={10.481}
        x2={10.481}
        y1={27.845}
        y2={28.431}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#141414" />
        <stop offset={1} stopColor="#141414" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="checkedBaggage_svg__g"
        x1={11.592}
        x2={18.755}
        y1={14.412}
        y2={14.412}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.131} stopColor="#fff" />
        <stop offset={0.137} stopColor="#EDEDED" />
        <stop offset={0.226} stopColor="#fff" />
        <stop offset={0.231} stopColor="#EDEDED" />
        <stop offset={0.423} stopColor="#fff" />
        <stop offset={0.433} stopColor="#EDEDED" />
        <stop offset={0.513} stopColor="#fff" />
        <stop offset={0.521} stopColor="#EDEDED" />
        <stop offset={0.765} stopColor="#fff" />
        <stop offset={0.771} stopColor="#EDEDED" />
        <stop offset={0.868} stopColor="#fff" />
        <stop offset={0.877} stopColor="#EDEDED" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="checkedBaggage_svg__h"
        x1={15.828}
        x2={22.347}
        y1={19.207}
        y2={19.207}
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.131} stopColor="#DBDBDB" />
        <stop offset={0.137} stopColor="#F0F0F0" />
        <stop offset={0.229} stopColor="#DBDBDB" />
        <stop offset={0.237} stopColor="#CFCFCF" />
        <stop offset={0.446} stopColor="#DBDBDB" />
        <stop offset={0.455} stopColor="#EFEFEF" />
        <stop offset={0.549} stopColor="#DBDBDB" />
        <stop offset={0.56} stopColor="#CFCFCF" />
        <stop offset={0.765} stopColor="#DBDBDB" />
        <stop offset={0.771} stopColor="#EFEFEF" />
        <stop offset={0.868} stopColor="#DBDBDB" />
        <stop offset={0.877} stopColor="#CFCFCF" />
        <stop offset={1} stopColor="#DBDBDB" />
      </linearGradient>
      <radialGradient
        id="checkedBaggage_svg__b"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.4 0 0 1.4 21.517 28.528)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#1F1F1F" />
        <stop offset={0.462} stopColor="#4D4D4D" />
        <stop offset={0.759} stopColor="#4D4D4D" />
        <stop offset={0.829} stopColor="#3B3B3B" />
        <stop offset={1} stopColor="#141414" />
      </radialGradient>
      <radialGradient
        id="checkedBaggage_svg__d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(1.4 0 0 1.4 10.481 28.528)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.33} stopColor="#1F1F1F" />
        <stop offset={0.462} stopColor="#4D4D4D" />
        <stop offset={0.759} stopColor="#4D4D4D" />
        <stop offset={0.829} stopColor="#3B3B3B" />
        <stop offset={1} stopColor="#141414" />
      </radialGradient>
      <radialGradient
        id="checkedBaggage_svg__f"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 10.7 -11.1 0 16.244 16.798)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0.633} stopColor="#4EA974" />
        <stop offset={1} stopColor="#2C8C54" />
      </radialGradient>
      <filter
        id="checkedBaggage_svg__a"
        width={20.6}
        height={3.8}
        x={5.7}
        y={28.102}
        filterUnits="userSpaceOnUse"
      >
        <feGaussianBlur stdDeviation={0.75} />
      </filter>
    </defs>
    <g filter="url(#checkedBaggage_svg__a)" opacity={0.5}>
      <ellipse cx={15.999} cy={30.002} fill="#000" rx={8.8} ry={0.4} />
    </g>
    <path
      fill="#B3B3B3"
      stroke="#868686"
      strokeWidth={0.776}
      d="M20.69 5.458h.69c.166 0 .301.136.302.302v.302h-1.294V5.76c0-.166.135-.302.301-.302Zm-10.07 0h.69c.166 0 .301.136.301.302v.302h-1.294V5.76c0-.166.136-.302.302-.302Z"
    />
    <path
      fill="#868686"
      d="M18.073 3.004h-4.14v2.76h-1.378v-2.76a1.38 1.38 0 0 1 1.379-1.379h4.14c.76 0 1.379.617 1.38 1.38v2.76h-1.38z"
    />
    <path
      fill="url(#checkedBaggage_svg__b)"
      d="M21.517 29.908a1.38 1.38 0 1 0 0-2.76 1.38 1.38 0 0 0 0 2.76"
    />
    <path
      fill="url(#checkedBaggage_svg__c)"
      d="M21.517 27.148c.762 0 1.38.618 1.38 1.38h-2.76c0-.762.617-1.38 1.38-1.38"
    />
    <path
      fill="url(#checkedBaggage_svg__d)"
      d="M10.481 29.908a1.38 1.38 0 1 0 0-2.76 1.38 1.38 0 0 0 0 2.76"
    />
    <path
      fill="url(#checkedBaggage_svg__e)"
      d="M10.481 27.148c.763 0 1.38.618 1.38 1.38h-2.76c0-.762.618-1.38 1.38-1.38"
    />
    <path
      fill="url(#checkedBaggage_svg__f)"
      d="M21.932 5.762H10.066a2.07 2.07 0 0 0-2.07 2.07v17.936a2.07 2.07 0 0 0 2.07 2.07h11.866a2.07 2.07 0 0 0 2.07-2.07V7.831a2.07 2.07 0 0 0-2.07-2.07Z"
    />
    <path
      fill="#1C1C1C"
      d="M19.45 3.695h-6.9v-.69c0-.763.618-1.38 1.38-1.38h4.14c.762 0 1.38.617 1.38 1.38z"
    />
    <path
      fill="#fff"
      d="M14.962 8.523a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345m-2.066 0a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345m-2.071 0a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345m6.207 0a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345m2.071 0a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345m2.07 0a.345.345 0 0 0-.345.345v15.867a.345.345 0 0 0 .69 0V8.868a.345.345 0 0 0-.345-.345"
      opacity={0.2}
    />
    <path
      fill="url(#checkedBaggage_svg__g)"
      d="M13.641 16.378a2 2 0 0 1-.4-.041c-.112-.024-.189-.138-.292-.179-.133-.052-.29-.037-.406-.116a1.965 1.965 0 0 1 0-3.26c.12-.08.216-.204.353-.257.104-.041.246-.018.357-.041a1.96 1.96 0 0 1 1.389.235c.136.08.262.122.374.231.119.116.22.301.308.444a1.96 1.96 0 0 1-.002 2.04c-.084.137-.222.17-.336.284s-.204.304-.343.387a2 2 0 0 1-1.002.273"
    />
    <path
      fill="url(#checkedBaggage_svg__h)"
      d="M17.048 21.605s-.188-.565-.384-.742l-.836-2.221.848-.319s.197-.18.364-.237c.168-.057.347-.03.347-.03l1.383-.521.327-.223.334-.027 1.404-.528s.298-.06.374-.043c.066.207.332.973.332.973l.806 2.143-.813.307s-.213.003-.38.06a1 1 0 0 0-.324.205l-1.378.52s-.172-.05-.356.027-.346.236-.346.236l-1.375.518c-.132-.055-.327-.098-.327-.098"
    />
  </svg>
);
export default SvgCheckedBaggage;
